import { DateLeg } from "./DateLeg";
import { joinPath } from "./paths";

type CustomSingleBodyProps = {
  valuesPath: string;
  isReadOnly?: boolean;
};

/** Body for `CUSTOM` + `SINGLE` — one date leg. */
export const CustomSingleBody = ({ valuesPath, isReadOnly = false }: CustomSingleBodyProps) => (
  <DateLeg
    legLabel="Date"
    parameterName={joinPath(valuesPath, "customStartParameter")}
    dateName={joinPath(valuesPath, "customStartDate")}
    isReadOnly={isReadOnly}
  />
);
